export enum WorkToFillEvents {
  CLOSE_COMMENTS = '@WorkToFill/CLOSE_COMMENTS',
  OPEN_COMMENTS = '@WorkToFill/OPEN_COMMENTS',
}
